import { SERVER_URL } from './../config/contants';
import { HEADERS } from './../config/contants';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { LocalStorageProvider } from '../providers/local-storage';

@Injectable()
export class EventosProvider {

  dados: any = [];
  pagina: number = 1;
  hasmore: boolean = false;
  contentHeader: Headers = new Headers(HEADERS);
  
  constructor(
    public http: Http,
    public storage: LocalStorageProvider
  ) {
  }

  refresh() {
    this.pagina = 1;
    this.hasmore = false;
    this.dados = [];
  }

  setPage(page) {
    this.pagina = page;
  }

  checkHasmore() {
    return this.hasmore;
  }

  getEventos() {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'eventos/eventos/', null, { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          this.storage.storageSave('eventos', data);
          resolve(data)
        },
        err => {
          reject(err)
        }
        );
    });
  }

  getEvento(id) {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'eventos/evento/', JSON.stringify({ id: id }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          resolve(data)
        },
        err => {
          reject(err)
        }
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/eventos.ts